// Auth helpers: armazena token + dados do operador no localStorage
const KEY = 'hilda.auth';

export function getAuth() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    // valida que token não expirou (decode rápido do payload sem libs)
    if (!parsed.token) return null;
    const payload = JSON.parse(atob(parsed.token.split('.')[1].replace(/-/g,'+').replace(/_/g,'/')));
    if (payload.exp && Math.floor(Date.now()/1000) > payload.exp) {
      localStorage.removeItem(KEY);
      return null;
    }
    return parsed;
  } catch { return null; }
}

export function setAuth(token, operador) {
  localStorage.setItem(KEY, JSON.stringify({ token, operador }));
}

export function clearAuth() {
  localStorage.removeItem(KEY);
}

// Decode rápido do payload pra usar em UI
export function decodeToken(token) {
  try {
    return JSON.parse(atob(token.split('.')[1].replace(/-/g,'+').replace(/_/g,'/')));
  } catch { return null; }
}
